import React from "react";
import { useLocation, useHref, useParams } from "react-router-dom";
import ChatIcon from "@mui/icons-material/Chat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import SchoolIcon from "@mui/icons-material/School";

import DrawerItem from "../drawer-item";
import StyledMenuMobile from "./styles";

const MenuMobile = () => {
  const href = useHref();

  return (
    <StyledMenuMobile>
      <div className="menu-mobile">
        <DrawerItem
          Icon={SchoolIcon}
          link="/grupos"
          active={href.includes("/area-socios/grupos")}
          open={false}
        />
        <DrawerItem
          Icon={CalendarMonthIcon}
          link="/calendar"
          active={href.includes("/area-socios/calendar")}
          open={false}
        />
        <DrawerItem
          Icon={AccountCircleIcon}
          link="/profile"
          active={href.includes("/area-socios/profile")}
          open={false}
        />

        <DrawerItem
          Icon={GroupIcon}
          link="/search"
          active={href.includes("/area-socios/search")}
          open={false}
        />
        <DrawerItem
          Icon={ChatIcon}
          link="/chat"
          active={href.includes("/area-socios/chat")}
          open={false}
        />
      </div>
    </StyledMenuMobile>
  );
};

export default MenuMobile;
